<template>
    <div class="">
        <div class="text-center md:hidden text-2xl font-bold p-4">
            Vay nhanh FastMoney
        </div>
        <div class="md:bg-gradient-to-r md:from-pink-500 md:via-red-500 md:to-pink-500  bg-gradient-to-b from-red-500 via-red-500 to-transparent rounded-t-xl md:rounded-t-none">
            
            <div class="container max-w-6xl grid grid-cols-2 md:pt-5 ">
                <list-content class="md:col-span-1 col-span-2 md:pl-0 pl-2" />
                <content-loan class="md:col-span-1 col-span-2" />
            </div>
        </div>
        <div class="mt-5 relative">
            <list-news class="mt-5 container max-w-6xl" />
            <div class="bg-active">
                <list-description class=" mt-3 container max-w-6xl" />
            </div>
            <slide-step class="pt-5 bg-white" />
            <div class="pt-3 bg-white">
                <list-partner class=" container max-w-6xl" />
            </div>
            
            <div class="pt-5 pb-5 bg-white">
                <fastmoney-intro class=" container max-w-6xl" />
            </div>
            
            <div @click="register" class="bg-active pl-3 pr-3 pt-1 pb-1 text-center  font-bold sticky bottom-0 display-mobile">
                 <div class="bg-main2 text-white p-2 rounded-md w-full"> ĐĂNG KÝ VAY </div>
            </div>
            <div @click="register" class="bg-active p-3 text-center cursor-pointer font-bold rounded-md sticky bottom-0 display-non-mobile">
                Vay ngay cùng FastMoney <span class="bg-main2 text-white p-2 rounded-md"> ĐĂNG KÝ VAY </span>
            </div>
        </div>
    </div>
</template>

<script>
import ListContent from './components/listContent.vue'
import ContentLoan from './components/contentLoan.vue'
import ListNews from './components/listNews.vue'
import ListDescription from './components/listDescription.vue'
import ListPartner from './components/listPartner.vue'
import SlideStep from './components/slideStep.vue'
import FastmoneyIntro from './components/fastmoneyIntro.vue'
export default {
    components: {
        ListContent,
        ContentLoan,
        ListNews,
        ListDescription,
        ListPartner,
        SlideStep,
        FastmoneyIntro
    },
    methods: {
        register(){
            window.location.href = 'https://vclick.vn'
        }
    },
    
}
</script>

<style>

</style>